import { Route, Switch } from 'react-router-dom';

// Components
import Catalog from '../Catalog';
import Header from '../Header';
import Consultancy from '../Consultancy';
import ShoppingCart from '../ShoppingCart';
import LastFooter from '../LastFooter';
import Footer from '../Footer';
import ConsultancyHome from '../ConsultancyHome';
import AddressSelect from '../AddressSelect';

// Styles
import styles from './index.module.sass';

export default function Cart({
  match,
  device,
  history,
  webservice,
  getCookie,
  screenSize,
  orderData,
  setOrderData,
  setSessionMessage,
  pathname,
}) {
  return (
    <div className={styles.cart}>
      <Header
        getCookie={getCookie}
        history={history}
        match={match}
        orderData={orderData}
        setOrderData={setOrderData}
        webservice={webservice}
        screenSize={screenSize}
        setSessionMessage={setSessionMessage}
        pathname={pathname}
      />
      <Switch>
        <Route
          exact
          path={`${match.path}/consultancy/home`}
          render={(props) => {
            return (
              <ConsultancyHome
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                match={match}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          path={`${match.path}/consultancy`}
          render={(props) => {
            return (
              <Consultancy
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                screenSize={screenSize}
                setSessionMessage={setSessionMessage}
                pathname={pathname}
              />
            );
          }}
        />
        <Route
          path={`${match.path}/selectaddress`}
          render={(props) => {
            return (
              <AddressSelect
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                screenSize={screenSize}
                setSessionMessage={setSessionMessage}
                pathname={pathname}
              />
            );
          }}
        />
        <Route
          path={`${match.path}/shoppingCart`}
          render={(props) => {
            return (
              <ShoppingCart
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                screenSize={screenSize}
                setSessionMessage={setSessionMessage}
                orderData={orderData}
                setOrderData={setOrderData}
              />
            );
          }}
        />
        <Route
          path={`${match.path}`}
          render={(props) => {
            return (
              <Catalog
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                screenSize={screenSize}
                setOrderData={setOrderData}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
      </Switch>
      <Footer screenSize={screenSize} history={history} />
      <LastFooter screenSize={screenSize} history={history} />
    </div>
  );
}
